require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./shot-dynamics-365-careers.json") })
        }
      }, "path---shot-dynamics-365-careers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---shot-dynamics-365-careers!./.cache/json/shot-dynamics-365-careers.json
// module id = 914
// module chunks = 231608221292675